import React from "react";
import DateTime from "./DateTime";
import CelsiusConversion from "./CelsiusConversion";

export default function SearchEngine(props) {
  return (
    <div className="SearchEngine">
      <h2>{props.info.city}</h2>
      <ul>
        <li>
          <DateTime date={props.info.dayTime} />
        </li>
        <li className="text-capitalize">{props.info.condition}</li>
      </ul>
      <div className="row mt-2">
        <div className="col-6">
          <img
            src={props.info.icon}
            alt={props.info.condition}
            className="float-left"
          />
          <CelsiusConversion fahrenheit={props.info.temperature} />
        </div>
        <div className="col-6 d-flex align-items-center justify-content-center">
          <ul>
            <li>Humidity: {props.info.humidity}%</li>
            <li>Wind: {props.info.wind} mph</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
